export default __webpack_public_path__ + "dbdb8e4834afb139601ca53365302f54.png";